import { StoryblokImageTextCol } from './StoryblokImageTextCol'

import { createImageTextCol } from './__mocks__/imageTextCol'

export { createImageTextCol }

// Re-export for backward compatibility
export const dummyImageTextColStoryblok = createImageTextCol()

export default StoryblokImageTextCol
